/* eslint-disable react-dom/no-missing-iframe-sandbox */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react/no-unstable-default-props */

/* eslint-disable no-use-before-define */

import { useFlags } from "launchdarkly-react-client-sdk";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { FaMinusCircle } from "react-icons/fa";
import { useHistory, useLocation } from "react-router-dom";
import { toast } from "react-toastify";

import useAppStore from "@/store/appStateZustand";
import { useUIStateStore } from "@/store/uiStateStore";

import {
  useGetMyProfile,
  useGetMySong,
  useGetMySongsDetailedPaginated,
  useGetMyWriters,
} from "../../../../api/queries";
import useSiteConfigAuth from "../../../../api/sanity/queries/getSiteConfigWithCode";
import FormError from "../../../../components/FormError";
import H2 from "../../../../components/H2";
import HR from "../../../../components/Hr";
import InnerRadio from "../../../../components/InnerRadio";
import Input from "../../../../components/Input";
import LoadingSmall from "../../../../components/LoadingSmall";
import MultipleInput from "../../../../components/MultipleInput";
import RebrandButtonLink from "../../../../components/RebrandButtonLink";
import RebrandPrimaryButton from "../../../../components/RebrandPrimaryButton";
import Spacer from "../../../../components/Spacer";
import SubModal from "../../../../components/SubModal";
import useGetColours from "../../../../helpers/getColours";
import {
  nameRegexTest,
  sanitizeInput,
  sendEvent,
  sendProperty,
  strToBool,
  titleRegexTest,
} from "../../../../helpers/helpers";
import AppState from "../../../../store/appstate";
import WritersForm from "../writers/WritersForm";
import { useRecordingOperations } from "./hooks/useRecordingOperations";
// Import our custom hooks
import { useSongOperations } from "./hooks/useSongOperations";
import { useSpotifyOperations } from "./hooks/useSpotifyOperations";
import SingleWriterWarningModal from "./SingleWriterWarningModal";
import SongWriterSplitCreate from "./SongWriterSplitCreate";

function SongsCreateUpdate(props) {
  const {
    id,
    closeForm,
    suggestion = null,
    onComplete = () => {},
    aac = null,
  } = props;
  const siteConfigData = useSiteConfigAuth();
  const [reset, setReset] = useState(0);
  const isUpdate = !!id;
  const { t } = useTranslation("songs");
  const [title, setTitle] = useState();
  const [durationmins, setDurationmins] = useState();
  const [durationsecs, setDurationsecs] = useState();
  const [isremix, setIsremix] = useState("false");
  const [containssamples, setContainssamples] = useState("false");
  const [performers, setPerformers] = useState();
  const [alternativetitles, setAlternativetitles] = useState();
  const [isLocked, setIsLocked] = useState(false);
  const [splits, setSplits] = useState([]);
  const [addNewWriterModalIsOpen, setAddNewWriterModalIsOpen] = useState(false);
  const flags = useFlags();
  const newAddSongs = flags["pd-add-songs-rework"];

  const [performingartist, setPerformingartist] = useState();
  const [isrc, setIsrc] = useState();
  const [releasedate, setReleasedate] = useState();
  const [pending, setPending] = useState(false);
  const { data: siteConfig } = useSiteConfigAuth();
  const { highlightColour } = useGetColours(siteConfig);
  const isTunecore = useUIStateStore(state => state.isTunecore);

  const [spotifySongIdentifier, setSpotifySongIdentifier] = useState(null);
  const [spotifyPopularity, setSpotifyPopularity] = useState(null);

  const [mutationErrorMessage, setMutationErrorMessage] = useState("");
  const [validationErrorMessage, setValidationErrorMessage] = useState("");
  const [spotifyLinkErrorMessage, setSpotifyLinkErrorMessage] = useState("");
  const [isWarningModalOpen, setIsWarningModalOpen] = useState(false);
  const [pendingSubmission, setPendingSubmission] = useState(null);
  const [spotifyURL, setSpotifyURL] = useState("");
  const [errors, setErrors] = useState({});
  const history = useHistory();

  // Get the selected account first before passing it to hooks
  // let selectedAccount = AppState.useState(s => s.selectedAccount);
  let selectedAccount = useAppStore(s => s.selectedAccount);
  if (aac) {
    selectedAccount = aac;
  }

  const {
    createSong,
    updateSong,
  } = useSongOperations({
    selectedAccount,
    onValidationError: (messages) => {
      setValidationErrorMessage(Array.isArray(messages) ? messages.join(", ") : messages);
    },
    onError: (message) => {
      setMutationErrorMessage(message);
    },
  });

  const {
    createRecording,
    updateRecordingMeta,
  } = useRecordingOperations({
    selectedAccount,
    onValidationError: (messages) => {
      setValidationErrorMessage(Array.isArray(messages) ? messages.join(", ") : messages);
    },
    onError: (message) => {
      setMutationErrorMessage(message);
    },
  });

  const {
    getSpotifyTrackByUrl,
    parseSpotifyUrl,
    autoLoadToken,
  } = useSpotifyOperations({
    onError: (message) => {
      setSpotifyLinkErrorMessage(message);
    },
  });

  const tableState = AppState.useState(s => s.songsTable);

  const songs = useGetMySongsDetailedPaginated({
    aac: selectedAccount,
    perPage: tableState.perPage,
    page: tableState.page,
    sortBy: tableState.sortBy?.[0]?.id,
    desc: tableState.sortBy?.[0]?.desc,
    globalFilter: tableState.globalFilter,
  });
  const song = useGetMySong({ aac: selectedAccount, wc: id, enabled: !!id });

  const updateWorkEtag = () => {
    song.refetch({ throwOnError: true });
  };
  const [justAddedWorkCode, setJustAddedWorkCode] = useState(null);

  const songJustAdded = useGetMySong({
    aac: selectedAccount,
    wc: justAddedWorkCode,
    enabled: !!justAddedWorkCode,
  });

  const profile = useGetMyProfile();

  const writers = useGetMyWriters({ aac: selectedAccount });

  const [spotifyResult, setSpotifyResult] = useState();
  const [agreeAddRecording, setAgreeAddRecording] = useState(true);
  const location = useLocation();

  // Load Spotify token when component mounts
  useEffect(() => {
    autoLoadToken();
  }, []);

  useEffect(() => {
    if (selectedAccount) {
      writers.refetch();
      song.refetch();
    }
  }, [selectedAccount]);

  if ((song.isError || song.data === null) && isUpdate) {
    history.push("/songs");
  }

  // if song just added, then also add recording
  useEffect(() => {
    let mounted = true;
    if (songJustAdded?.data && mounted) {
      // Prevent multiple calls
      setJustAddedWorkCode(null);
      addRecording();
    }
    return () => {
      mounted = false;
    };
  }, [songJustAdded.data]);

  if (song.isSuccess && id && !title) {
    setIsLocked(song.data.islocked);
    setTitle(song.data.title);
    setDurationmins(song.data.durationmins);
    setDurationsecs(song.data.durationsecs);
    setIsremix(song.data.isremix ? "true" : "false");
    setContainssamples(song.data.containssamples ? "true" : "false");
    setPerformers(
      song.data.performingartists
        .map(a => ({
          ...a,
          name: a.performingartistname,
        }))
        .filter(p => !p.isdeleted),
    );
    setAlternativetitles(
      song.data?.alternativetitles.filter(p => !p.isdeleted),
    );

    setSplits(
      song.data.writersplits.map((w) => {
        const writer = writers.data.writers.find(
          writer => writer.writercode === w.writercode,
        );
        return {
          ...w,
          righttocollect: w.righttocollect ? "true" : "false",
          writer,
        };
      }),
    );
  }

  if (suggestion && !title) {
    const tr = suggestion;

    setTitle(tr.title);

    setDurationmins(Math.floor(tr.duration / 1000 / 60));

    setDurationsecs(Math.floor((tr.duration / 1000) % 60));

    setPerformers(
      tr.artists.split(",").map(a => ({
        name: a.replace(/&#44;/g, ","),
      })),
    );

    const date = tr?.release_date?.length === 4
      ? `${tr.release_date}-01-01`
      : tr?.release_date;

    setReset(reset + 1);
    setPerformingartist(tr.artists.split(",")[0]);
    setIsrc(tr?.isrc);
    setSpotifyResult(tr);
    setSpotifySongIdentifier(tr?.spotify_song_id);
    setSpotifyPopularity(tr?.popularity);
    setReleasedate(date);
    setAgreeAddRecording(true);
  }

  const checkErrors = (field) => {
    let errs = {};
    if (field) {
      errs = JSON.parse(JSON.stringify(errors));
      delete errs[field];
    }

    let valid = true;
    // title check

    if (!field || field === "title") {
      const validTitle = title?.trim().length > 0;
      if (!validTitle) {
        errs.title = t("regex:song-title-regex");
        valid = false;
      }

      if (title && !titleRegexTest(title)) {
        errs.title = t("regex:invalid-characters");
        valid = false;
      }
    }

    if (!field || field === "alternativetitles") {
      if (alternativetitles) {
        alternativetitles.forEach((p) => {
          if (!p?.title || p.title.trim().length < 1) {
            errs.alternativetitles = t("regex:song-alternative-title-regex");
            valid = false;
          }
          else if (p.title && !titleRegexTest(p.title)) {
            errs.alternativetitles = t("regex:invalid-characters");
            valid = false;
          }
        });
      }
    }

    if (!field || field === "performers") {
      // has at least one performer
      if (!performers || performers.length < 1) {
        errs.performers = t("regex:song-performer-regex");
        valid = false;
      }

      // check valid performer names
      if (performers) {
        performers.forEach((p) => {
          if (!p?.name || p.name.trim().length < 1) {
            errs.performers = t("regex:song-performer-name-regex");
            valid = false;
          }
          else if (p.name.length > 44) {
            errs.performers = t("regex:song-performer-max-length-regex");
            valid = false;
          }
          else if (p.name && !nameRegexTest(p.name)) {
            errs.performers = t("regex:invalid-characters2");
            valid = false;
          }
        });
      }
    }
    if (!field || field === "writers") {
      if (!splits && !field) {
        errs.writers = t("regex:add-songwriter-regex");
        valid = false;
      }
      if (splits) {
        let total = 0;
        let fieldError = false;
        splits.forEach((p) => {
          if (
            !field
            && (!p?.writercode
              || !p?.righttocollect
              || !p?.writershare
              || !p?.writerdesignationcode)
          ) {
            errs.writers = t("regex:select-a-writer-regex");
            valid = false;
            fieldError = true;
          }
          else if (p.writershare) {
            total += Number(p.writershare);

            total = Number(total.toFixed(2));

            if (p.writershare.toString().includes(".")) {
              const decimalLength = p.writershare.toString().length
                - (p.writershare.toString().indexOf(".") + 1);
              if (decimalLength > 2) {
                errs.writers = t("regex:writer-splits-regex");
                valid = false;
              }
            }
          }
          else {
            fieldError = true;
          }
        });
        if (total !== 100 && !fieldError) {
          errs.writers = t("regex:writer-share-regex");
          valid = false;
        }
      }
      if (splits) {
        let atLeastOneRightToCollect = false;
        splits.forEach((p) => {
          if (strToBool(p.righttocollect)) {
            atLeastOneRightToCollect = true;
          }
        });

        if (!atLeastOneRightToCollect) {
          errs.writers = t("regex:writer-right-to-collect-regex");
          valid = false;
        }
      }

      if (siteConfigData.data.ipicae_required && splits) {
        splits.forEach((p) => {
          if (
            p.righttocollect === "true"
            && (!p.writer.caeipinumber
              || p.writer.caeipinumber === ""
              || p.writer.caeipinumber === null
              || p.writer.caeipinumber === undefined)
          ) {
            errs.writers = t("regex:writer-missing-cae-regex");
            valid = false;
          }
        });
      }

      if (siteConfigData.data.date_of_birth_required && splits) {
        splits.forEach((p) => {
          if (
            p.righttocollect === "true"
            && (!p.writer.dateofbirth || p.writer.dateofbirth === "")
          ) {
            errs.writers = t("regex:writer-missing-dob-regex");
            valid = false;
          }
        });
      }
    }

    setErrors(errs);
    return valid;
  };

  // Removed addSongSuccess function as we now handle toast and redirect directly
  // where needed to avoid race conditions between multiple redirects

  // const validationFailed = (message) => {
  //   if (
  //     message.toString().includes("There is an existing record, Work code(s)")
  //   ) {
  //     setValidationErrorMessage("This song has already been added.");
  //   }
  //   else {
  //     setMutationErrorMessage(message);
  //   }
  //   setPending(false);
  // };

  const checkWriterCountAndProceed = (submissionType) => {
    // Set pending state immediately when button is clicked
    setPending(true);

    if (
      splits.length === 1
      && localStorage.getItem("showWriterWarning") !== "false"
    ) {
      setPendingSubmission(() => submissionType);
      setIsWarningModalOpen(true);
      // If the modal is shown, we're not actually submitting yet
      setPending(false);
    }
    else {
      submissionType();
    }
  };

  const handleWarningConfirm = () => {
    setIsWarningModalOpen(false);
    if (pendingSubmission) {
      const executeSubmission = pendingSubmission;
      setPendingSubmission(null);
      // Set pending state back to true before executing the submission
      setPending(true);
      executeSubmission();
      sendEvent({ property: "pe14489857_single_writer_check___confirm_song" });
    }
  };

  const handleWarningClose = () => {
    setIsWarningModalOpen(false);
    setPendingSubmission(null);
    sendEvent({ property: "pe14489857_single_writer_check___cancel" });
  };

  const addSong = async () => {
    setPending(true);
    setMutationErrorMessage("");
    setValidationErrorMessage("");

    const valid = checkErrors();

    if (valid) {
      let alts = [];
      if (alternativetitles) {
        alts = alternativetitles.filter(a => a.title.length > 0);
      }

      const songData = {
        title,
        durationmins,
        durationsecs,
        isremix,
        containssamples,
        alternativetitles: alts,
        performingartistnames: performers,
        writersplits: splits || [],
      };

      try {
        const response = await createSong(songData);

        if (spotifyResult && agreeAddRecording === true) {
          setJustAddedWorkCode(response.model.workcode);
        }
        else {
          // Show success toast and redirect for non-Spotify case
          toast.success(`${t("songs:song-added-toast")}: ${title}`, {
            position: "bottom-right",
            autoClose: 5000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
          });

          sendProperty({
            property: "last_song_added",
            value: "CURRENT_DATE",
            email: profile?.data?.email,
          });
          sendEvent({ property: "pe14489857_last_song_added" });

          songs.refetch();
          setPending(false);

          // Delay the redirect slightly to ensure toast is visible
          // Use a more aggressive approach to ensure the redirect happens
          setTimeout(() => {
            console.log("Redirecting to /songs after song creation");
            history.push("/songs");

            // Double-check the redirect after a short delay
            setTimeout(() => {
              if (window.location.pathname !== "/songs") {
                console.log("Redirect check failed, forcing navigation");
                window.location.href = "/songs";
              }
            }, 300);
          }, 600);
        }
      }
      catch {
        // Error handling is done in the hooks via onError and onValidationError callbacks
        setPending(false);
      }
    }
    else {
      setPending(false);
    }
  };

  const update = async () => {
    setPending(true);
    setMutationErrorMessage("");
    setValidationErrorMessage("");

    const valid = checkErrors();

    if (valid) {
      let alts = [];
      if (alternativetitles) {
        alts = alternativetitles.filter(a => a.title.length > 0);
      }

      alts = alts.map(a => ({
        title: a.title,
        alternativetitleidentifier: Object.prototype.hasOwnProperty.call(a, "alternativetitleidentifier")
          ? a.alternativetitleidentifier
          : "00000000-0000-0000-0000-000000000000",
        alternativetitleamendmentidentifier: Object.prototype.hasOwnProperty.call(a, "alternativetitleamendmentidentifier")
          ? a.alternativetitleamendmentidentifier
          : "00000000-0000-0000-0000-000000000000",
      }));

      const songData = {
        title,
        durationmins,
        durationsecs,
        isremix,
        containssamples,
        alternativetitles: alts,
        performingartistnames: performers,
        writersplits: splits,
        workcode: song.data.workcode,
        etag: song.data.etag,
        iswc: song.data.iswc,
        recordings: song.data.recordings,
      };

      try {
        await updateSong(songData);
        song.refetch();
        songs.refetch();

        if (isUpdate) {
          closeForm();
        }
        else {
          history.push("/songs");
        }
        setPending(false);
      }
      catch {
        // Error handling is done in the hooks via onError and onValidationError callbacks
        setPending(false);
      }
    }
    else {
      setPending(false);
    }
  };

  const addRecording = async () => {
    setPending(true);
    setMutationErrorMessage("");
    setValidationErrorMessage("");

    const valid = checkErrors();

    if (valid) {
      const recordingData = {
        title: sanitizeInput(title),
        performingartist: sanitizeInput(performingartist),
        isrc,
        releasedate,
        workcode: songJustAdded.data.workcode,
        spotifyidentifier: spotifySongIdentifier ?? null,
        spotifypopularity: spotifyPopularity ?? null,
        etag: songJustAdded.data.etag,
      };

      try {
        const result = await createRecording(recordingData);
        console.log("Recording created successfully:", result);

        const recordingId = result.recordingidentifier;

        // Handle the recording metadata differently based on whether we have a suggestion
        if (suggestion) {
        // Use suggestion data for recording meta
          let imagesArray = [];
          if (suggestion.images) {
            try {
              imagesArray = JSON.parse(suggestion.images);
            }
            catch (e) {
              console.error("Error parsing images JSON", e);
            }
          }

          const metaData = {
            id: recordingId,
            spotify_id: suggestion.spotify_song_id ?? "",
            mp3: null,
            thumb_url: imagesArray.length > 0 ? imagesArray[0].url : null,
            song_id: songJustAdded.data.workcode,
          };

          await updateRecordingMeta(metaData);

          // For suggestions, call onComplete and let parent handle the flow
          onComplete();
          setPending(false);
          return; // Exit early for suggestion flow
        }
        else {
        // Use Spotify result data for recording meta
          const metaData = {
            id: recordingId,
            spotify_id: spotifyResult ? spotifyResult.id : null,
            mp3: null,
            thumb_url: spotifyResult?.album?.images?.[0]?.url ?? null,
            song_id: songJustAdded.data.workcode,
          };

          await updateRecordingMeta(metaData);
        }

        // Send analytics events
        sendProperty({
          property: "last_recording_added",
          value: "CURRENT_DATE",
          email: profile?.data?.email,
        });
        sendEvent({ property: "pe14489857_recording_added" });

        // Send song added property as well since this completes the song+recording flow
        sendProperty({
          property: "last_song_added",
          value: "CURRENT_DATE",
          email: profile?.data?.email,
        });
        sendEvent({ property: "pe14489857_last_song_added" });

        // Refetch songs data
        songs.refetch();

        // Show success toast for the completed song+recording creation
        toast.success(`${t("songs:song-added-toast")}: ${title}`, {
          position: "bottom-right",
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });

        // Set pending to false before redirect
        setPending(false);

        // Redirect after a short delay to ensure toast is visible
        setTimeout(() => {
          console.log("Redirecting to /songs after song+recording creation");
          history.push("/songs");

          // Fallback redirect check
          setTimeout(() => {
            if (window.location.pathname !== "/songs") {
              console.log("Redirect check failed, forcing navigation");
              window.location.href = "/songs";
            }
          }, 300);
        }, 600);
      }
      catch (error) {
        console.error("Error in addRecording:", error);
        // Error handling is done in the hooks via onError and onValidationError callbacks
        setPending(false);
      }
    }
    else {
      setPending(false);
    }
  };

  const handleSpotifyURLSubmit = async (e) => {
    e.preventDefault();
    setPending(true);

    try {
      const trackId = parseSpotifyUrl(spotifyURL);

      if (trackId) {
        const track = await getSpotifyTrackByUrl(spotifyURL);
        if (track) {
          handleChangeSpotifyResult(track);
          setSpotifyLinkErrorMessage("");
        }
        else {
          setSpotifyLinkErrorMessage(
            t("songs:link-spotify-track-invalid-url-error"),
          );
        }
      }
      else {
        setSpotifyLinkErrorMessage(
          t("songs:link-spotify-track-invalid-url-error"),
        );
      }
    }
    catch (error) {
      console.error("Error fetching track:", error);
      setSpotifyLinkErrorMessage(
        t("songs:link-spotify-track-invalid-url-error"),
      );
    }
    finally {
      setPending(false);
    }
  };

  const handleChangeSpotifyResult = (track) => {
    const date = track.album.release_date?.length === 4
      ? `${track.album.release_date}-01-01`
      : track.album.release_date;
    setTitle(sanitizeInput(track.name));
    setDurationmins(Math.floor(track.duration_ms / 1000 / 60));
    setDurationsecs(Math.floor((track.duration_ms / 1000) % 60));
    setPerformers(
      track.artists.map(a => ({
        name: a.name,
      })),
    );
    setReset(reset + 1);
    setPerformingartist(sanitizeInput(track.artists[0].name));
    setIsrc(track?.external_ids?.isrc);
    setReleasedate(date);
    setSpotifySongIdentifier(track.id);
    setSpotifyPopularity(track.popularity);
    setSpotifyResult(track);
  };

  const removeSpotify = () => {
    setTitle("");
    setDurationmins("");
    setDurationsecs("");
    setPerformers(null);
    setAlternativetitles(null);
    setPerformingartist("");
    setIsrc(null);
    setReleasedate(null);
    setSpotifySongIdentifier(null);
    setSpotifyPopularity(null);
    setSpotifyResult(null);
    setReset(reset + 1);
    setSpotifyURL("");
  };

  const setWriterSplitFields = (splitArray) => {
    setSplits(splitArray);
  };

  return (
    <>
      <SingleWriterWarningModal
        isOpen={isWarningModalOpen}
        onConfirm={handleWarningConfirm}
        onClose={handleWarningClose}
      />

      <SubModal
        openSubPortal={addNewWriterModalIsOpen}
        closeSubPortal={setAddNewWriterModalIsOpen}
      >
        <WritersForm modal closeForm={setAddNewWriterModalIsOpen} />
      </SubModal>

      <div className="flex flex-wrap lg:min-h-screen-minus-header">
        <div
          className={`w-full ${
            location.pathname === "/songs" ? "lg:p-6 p-4" : ""
          } ${
            newAddSongs
              ? ""
              : location.pathname === "/songs/create"
                ? "lg:min-h-screen-minus-header mx-4 lg:mx-12 xl:mx-20 2xl:mx-40 my-12"
                : "lg:p-6 p-4 lg:min-h-screen-minus-header"
          } ${isTunecore ? "text-white" : ""}`}
        >
          <div className="">
            {!suggestion && (
              <div className="flex flex-col-reverse items-start justify-between mb-8 sm:items-baseline sm:flex-row">
                <H2>
                  {isUpdate ? t("songs:update-header") : t("songs:add-header")}
                  {" "}
                  {t("songs:song")}
                </H2>
                {!isUpdate && (
                  <RebrandButtonLink
                    id="btnSongFormCancel"
                    onClick={() => history.push("/songs")}
                  >
                    {t("songs:cancel-and-return")}
                  </RebrandButtonLink>
                )}
              </div>
            )}
            <div>
              {(!id || (id && song.isSuccess && song.data !== null)) && (
                <>
                  <div className="w-full">
                    {!isUpdate && !suggestion && (
                      <>
                        {/* SPOTIFY COMPONENT */}
                        <div
                          style={{
                            backgroundColor: isTunecore
                              ? "#282828"
                              : highlightColour,
                          }}
                          className={
                            isTunecore
                              ? "text-white px-14 py-10 rounded-lg"
                              : "px-14 py-10 rounded-lg text-old-sentric-dark-gray"
                          }
                        >
                          <h2 className="text-xl">
                            {t("songs:import-from-spotify-header")}
                          </h2>
                          <Spacer thin />
                          <p className="font-sentric-alt">
                            {t("songs:import-from-spotify-text")}
                            {" "}
                            <span>
                              <a
                                className="underline hover:scale-105"
                                href="https://support.spotify.com/us/artists/article/finding-your-artist-url/"
                              >
                                {t("songs:link-spotify-instructions-link")}
                              </a>
                            </span>
                          </p>
                          <Spacer />
                          <div className="flex flex-col">
                            {!spotifyResult && (
                              <>
                                <Input
                                  blackLabel
                                  type="text"
                                  placeholder={t(
                                    "songs:link-spotify-paste-track-url",
                                  )}
                                  value={spotifyURL}
                                  onChange={e =>
                                    setSpotifyURL(e.target.value)}
                                  error={spotifyLinkErrorMessage}
                                  className="w-full mb-4 form-input"
                                />
                                <div className="self-end">
                                  <RebrandPrimaryButton
                                    type="submit"
                                    onClick={handleSpotifyURLSubmit}
                                    arrow
                                  >
                                    {t("songs:link-spotify-fetch-track")}
                                  </RebrandPrimaryButton>
                                </div>
                              </>
                            )}
                            {spotifyResult && (
                              <>
                                <div>
                                  <iframe
                                    title="preview"
                                    src={`https://open.spotify.com/embed/track/${spotifyResult.id}`}
                                    height="80"
                                    allow="encrypted-media"
                                    className="w-full lg:w-3/4"
                                  />
                                </div>
                                <Spacer thin />
                                <div>
                                  <button
                                    type="button"
                                    id="btnSongFormRemoveSelection"
                                    className={`${
                                      isTunecore
                                        ? "text-white hover:text-tunecore-green"
                                        : "text-black font-sentric-alt hover:scale-105"
                                    } underline flex items-center`}
                                    onClick={removeSpotify}
                                  >
                                    <FaMinusCircle className="mr-2" />
                                    {" "}
                                    <span>{t("songs:remove-selection")}</span>
                                  </button>
                                </div>
                                <Spacer />
                                <InnerRadio
                                  name="agreeaddrecording"
                                  label={t(
                                    "songs:add-spotify-song-as-recording-confirm",
                                  )}
                                  value={agreeAddRecording}
                                  onChange={e =>
                                    setAgreeAddRecording(e.target.value)}
                                  options={[
                                    {
                                      label: t("common:yes"),
                                      value: true,
                                    },
                                    { label: t("common:no"), value: false },
                                  ]}
                                />
                              </>
                            )}
                          </div>
                        </div>
                      </>
                    )}
                    {!isUpdate && !suggestion && (
                      <>
                        <Spacer />
                        <HR />
                      </>
                    )}
                    <Spacer />
                    {/* ELEMENT STARTS */}
                    <div className="w-full">
                      <h2 className="text-xl">
                        {t("songs:song-details-header")}
                      </h2>
                      <Spacer thin />
                      <div className="flex flex-col w-full gap-6 lg:flex-row lg:gap-12">
                        <div className="flex flex-col w-full space-y-8">
                          <Input
                            className="form-input"
                            id="txtSongFormTitle"
                            required
                            type="text"
                            error={errors.title}
                            placeholder={t("songs:title-placeholder")}
                            value={title}
                            onBlur={() => {
                              checkErrors("title");
                            }}
                            onChange={(e) => {
                              setTitle(e.target.value);
                            }}
                          />
                          <MultipleInput
                            id="txtSongFormAltTitle"
                            name="txtSongFormAltTitle"
                            type="text"
                            addAnotherText={t("songs:add-another-title-button")}
                            error={errors.alternativetitles}
                            onBlur={() => {
                              checkErrors("alternativetitles");
                            }}
                            placeholder={t(
                              "songs:alternative-title-placeholder",
                            )}
                            valueKey="title"
                            value={alternativetitles}
                            onChange={(arr) => {
                              setAlternativetitles(arr);
                            }}
                            infoTooltip={t(
                              "regex:song-alternative-title-description-regex",
                            )}
                          />
                        </div>
                        <div
                          className={`${
                            isTunecore
                              ? "bg-tunecore-light-grey"
                              : "bg-sentric-rebrand-mid-grey"
                          } hidden md:block w-[2px]`}
                        />
                        <div className="flex flex-col w-full space-y-8">
                          <div className="flex">
                            <Input
                              id="txtSongFormMin"
                              className="w-40 mr-2 lg:w-full"
                              type="number"
                              error={errors.durationmins}
                              placeholder={t("common:mins-capital")}
                              onBlur={() => {}}
                              value={durationmins}
                              onKeyDown={(e) => {
                                if (
                                  e.keyCode === 69
                                  || e.keyCode === 190
                                  || e.keyCode === 110
                                  || e.keyCode === 107
                                  || e.keyCode === 187
                                  || e.keyCode === 109
                                  || e.keyCode === 189
                                ) {
                                  e.preventDefault();
                                }
                              }}
                              onChange={(e) => {
                                setDurationmins(e.target.value);
                              }}
                              min="0"
                              max="120"
                              step="1"
                            />
                            <Input
                              id="txtSongFormSec"
                              className="w-40 lg:w-full"
                              type="number"
                              error={errors.durationsecs}
                              placeholder={t("common:secs-capital")}
                              value={durationsecs}
                              onBlur={() => {}}
                              onKeyDown={(e) => {
                                if (
                                  e.keyCode === 69
                                  || e.keyCode === 190
                                  || e.keyCode === 110
                                  || e.keyCode === 107
                                  || e.keyCode === 187
                                  || e.keyCode === 109
                                  || e.keyCode === 189
                                ) {
                                  e.preventDefault();
                                }
                              }}
                              onChange={(e) => {
                                setDurationsecs(e.target.value);
                              }}
                              min="0"
                              max="59"
                              step="1"
                            />
                          </div>
                          <div>
                            <MultipleInput
                              name="txtSongFormPerformers"
                              required
                              type="text"
                              maxLength={45}
                              reset={reset}
                              error={errors.performers}
                              placeholder={t("songs:performing-artists")}
                              addAnotherText={t(
                                "songs:add-another-performer-button",
                              )}
                              valueKey="name"
                              value={performers}
                              onBlur={() => {
                                checkErrors("performers");
                              }}
                              onChange={(arr) => {
                                setPerformers(arr);
                              }}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <Spacer />
                    <HR />
                    <Spacer />

                    <SongWriterSplitCreate
                      onWorkSplitFieldUpdate={setWriterSplitFields}
                      onWriterModalOpen={setAddNewWriterModalIsOpen}
                      errors={errors}
                      existingSplits={splits}
                      updateWorkEtag={updateWorkEtag}
                    />

                    <Spacer />
                    <HR />
                    <Spacer />

                    <div className="w-full lg:w-2/3">
                      <InnerRadio
                        name="isremix"
                        label={t("songs:is-this-a-remix")}
                        value={isremix}
                        onChange={e => setIsremix(e.target.value)}
                        options={[
                          { label: t("common:yes"), value: true },
                          { label: t("common:no"), value: false },
                        ]}
                        infoTooltip={t("songs:is-this-a-remix-description")}
                      />

                      <Spacer />
                      <InnerRadio
                        name="containssamples"
                        label="Does this song contain samples?"
                        value={containssamples}
                        onChange={e => setContainssamples(e.target.value)}
                        options={[
                          { label: t("common:yes"), value: true },
                          { label: t("common:no"), value: false },
                        ]}
                        infoTooltip={t("songs:contains-samples-description")}
                      />
                    </div>

                    <Spacer />
                    <HR />
                    <Spacer />

                    <div className="w-full max-w-xl">
                      <Spacer thin />
                      <Spacer />
                    </div>
                    <Spacer thin />
                    <FormError
                      mutationError={mutationErrorMessage}
                      validationError={validationErrorMessage}
                    />
                    <div
                      className={`flex flex-wrap items-center gap-4 ${
                        suggestion ? "justify-end" : "justify-between"
                      }`}
                    >
                      <>
                        <div
                          className={`${suggestion ? "order-2" : "order-1"}`}
                        >
                          <RebrandPrimaryButton
                            id={
                              isUpdate
                                ? "btnSongFormUpdateSong"
                                : "btnSongFormAddSong"
                            }
                            onClick={() =>
                              checkWriterCountAndProceed(
                                isUpdate ? update : addSong,
                              )}
                            disabled={pending || isLocked}
                            pending={pending}
                            arrow={!isTunecore}
                          >
                            {isUpdate
                              ? t("songs:update-song-button")
                              : t("songs:add-song-button")}
                          </RebrandPrimaryButton>
                        </div>
                        <div
                          className={`${
                            suggestion ? "order-1" : "order-2"
                          } mt-2 sm:mt-0 flex justify-center `}
                        >
                          <RebrandButtonLink
                            id={
                              isUpdate
                                ? "btnSongFormCancelUpdateReturn"
                                : "btnSongFormCancelReturn"
                            }
                            onClick={
                              isUpdate
                                ? closeForm
                                : () =>
                                    suggestion
                                      ? history.go(0)
                                      : history.push("/songs")
                            }
                          >
                            {!suggestion
                              ? t("songs:cancel-and-return")
                              : t("songs:cancel-and-discard")}
                          </RebrandButtonLink>
                        </div>
                      </>
                    </div>
                  </div>
                </>
              )}
              {id && song.isLoading && <LoadingSmall />}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
export default SongsCreateUpdate;
